module.exports = __webpack_public_path__ + "static/media/8OLA15.55d76fa4.jpg";